import fetch from 'auth/FetchInterceptor'

const clienteService = {}

clienteService.all = function () {
  return fetch({
    url: '/ses/all',
    method: 'get',
    headers: {
        'Content-Type': 'application/json',
      },
  })
}

clienteService.paginated = function ({ page = 0, size = 10, email = '' } = {}) {
  return fetch({
    url: '/ses',
    method: 'get',
    params: { page, size, email },
  })
}

export default clienteService